import { FC } from 'react';
import { useCoresPainel } from '@/components/paineis/chartTheme';
import PainelMaquinas from '@/components/paineis/maquinas/PainelMaquinas';
import PainelShell from '@/components/paineis/PainelShell';
import { usePainelFiltrado } from '@/hooks/usePainelFiltrado';
import { dashboardsService } from '@/services/dashboards.service';
import type { MaquinasPayload } from '@/types/dashboards';

const buscarMaquinas = (params: Record<string, string>) => dashboardsService.getEquiplexMaquinas(params);

/**
 * Relatório Daily (`/paineis/equiplex/maquinas`; até 27/10/2026, "Por máquina (MFR)") — em duas
 * abas: a daily por linha da reunião das 08:00 e o MFR de cada máquina, que hoje sai de uma
 * planilha montada à mão: programado × produzido por dia, semana e mês, direto do Datasul. Lê o
 * último snapshot; nenhuma planilha entra. A rota fica a mesma: link antigo continua abrindo.
 */
const EquiplexMaquinasPage: FC = () => {
  const cores = useCoresPainel();
  const { estado, barra } = usePainelFiltrado<MaquinasPayload>(buscarMaquinas);
  return (
    <PainelShell
      estado={estado}
      prefixo="maq"
      origem="maquinas"
      titulo="Relatório Daily"
      subtitulo="Aba Daily: a produção por linha (sopro e envase) contra a programação, com a projeção do mês. Aba MFR: o programado × produzido de cada máquina por dia, semana e mês, e as OPs sem apontamento."
      corte={(p) => p.corte}
    >
      {({ id, payload }) => (
        <>
          {barra(payload.recorte, undefined, payload.frescor?.dados_ate)}
          <PainelMaquinas key={id} payload={payload} cores={cores} onMetasSalvas={estado.carregar} />
        </>
      )}
    </PainelShell>
  );
};

export default EquiplexMaquinasPage;
